import axios from 'axios'

/** 所有 ApiDoc V3 請求帶上操作者，供後端 Activity Log 寫入 */
axios.interceptors.request.use((config) => {
  const url = config.url || ''
  if (url.includes('/api/api-doc/v3/')) {
    const username = typeof localStorage !== 'undefined'
      ? localStorage.getItem('editor-username')
      : null
    if (username) {
      config.headers = config.headers || {}
      config.headers['X-Editor-Username'] = username
    }
  }
  return config
})

export const getDocs = async () => {
  try {
    const res = await axios.get('/api/api-doc/v3/docs')
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getDoc = async (docId) => {
  const encodedDocId = encodeURIComponent(docId)
  try {
    const res = await axios.get(`/api/api-doc/v3/doc/${encodedDocId}`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const createDoc = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v3/docs', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const duplicateDoc = async ({ sourceDocId, ...data }) => {
  const encodedSourceDocId = encodeURIComponent(sourceDocId)
  try {
    const res = await axios.post(`/api/api-doc/v3/docs/${encodedSourceDocId}/duplicate`, data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const updateDoc = async (data) => {
  const encodedDocId = encodeURIComponent(data.docId)
  try {
    const res = await axios.post(`/api/api-doc/v3/docs/${encodedDocId}`, data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const deleteDoc = async (docId) => {
  const encodedDocId = encodeURIComponent(docId)
  try {
    const res = await axios.post(`/api/api-doc/v3/docs/${encodedDocId}/delete`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const batchDeleteDocs = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v3/docs/batch-delete', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getSections = async () => {
  try {
    const res = await axios.get('/api/api-doc/v3/sections')
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getSectionsByDocId = async (docId) => {
  const encodedDocId = encodeURIComponent(docId)
  try {
    const res = await axios.get(`/api/api-doc/v3/sections/${encodedDocId}`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getSection = async ({ docId, sectionId }) => {
  const encodedDocId = encodeURIComponent(docId)
  const encodedSectionId = encodeURIComponent(sectionId)
  try {
    const res = await axios.get(`/api/api-doc/v3/sections/${encodedDocId}/${encodedSectionId}`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const createSection = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v3/sections', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const duplicateSection = async ({ sourceSectionId, ...data }) => {
  const encodedDocId = encodeURIComponent(data.docId)
  const encodedSourceSectionId = encodeURIComponent(sourceSectionId)
  try {
    const res = await axios.post(`/api/api-doc/v3/sections/${encodedDocId}/${encodedSourceSectionId}/duplicate`, data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const moveSectionToPeerWallet = async ({ sourceDocId, ...sectionData }) => {
  const encodedSourceDocId = encodeURIComponent(sourceDocId)
  const encodedSectionId = encodeURIComponent(sectionData.sectionId)
  try {
    const res = await axios.post(`/api/api-doc/v3/sections/${encodedSourceDocId}/${encodedSectionId}/move`, sectionData)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const updateSection = async (data) => {
  const encodedDocId = encodeURIComponent(data.docId)
  const encodedSectionId = encodeURIComponent(data.sectionId)
  try {
    const res = await axios.post(`/api/api-doc/v3/sections/${encodedDocId}/${encodedSectionId}`, data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const batchWriteSections = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v3/sections/batch-write', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const deleteSection = async ({ sectionId, docId }) => {
  const encodedDocId = encodeURIComponent(docId)
  const encodedSectionId = encodeURIComponent(sectionId)
  try {
    const res = await axios.post(`/api/api-doc/v3/sections/${encodedDocId}/${encodedSectionId}/delete`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const batchDeleteSections = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v3/sections/batch-delete', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

// ==================== Fields API (新增) ====================
export const getFields = async () => {
  try {
    const res = await axios.get('/api/api-doc/v3/fields')
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getFieldsBySectionId = async ({ docId, sectionId, scope = null }) => {
  const encodedDocId = encodeURIComponent(docId)
  const encodedSectionId = encodeURIComponent(sectionId)
  const params = scope ? { scope } : {}

  try {
    const res = await axios.get(`/api/api-doc/v3/sections/${encodedDocId}/${encodedSectionId}/fields`, { params })
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getField = async (docId, sectionId, fieldId, scope) => {
  const encodedDocId = encodeURIComponent(docId)
  const encodedSectionId = encodeURIComponent(sectionId)
  const encodedFieldId = encodeURIComponent(fieldId)

  try {
    const res = await axios.get(`/api/api-doc/v3/fields/${encodedDocId}/${encodedSectionId}/${encodedFieldId}`, {
      params: { scope },
    })
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const updateField = async (docId, sectionId, fieldId, scope, data) => {
  const encodedDocId = encodeURIComponent(docId)
  const encodedSectionId = encodeURIComponent(sectionId)
  const encodedFieldId = encodeURIComponent(fieldId)

  try {
    const res = await axios.post(`/api/api-doc/v3/fields/${encodedDocId}/${encodedSectionId}/${encodedFieldId}`, {
      scope,
      ...data,
    })
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

/**
 * @param {string} docId
 * @param {string} sectionIdFieldId - `${sectionId}#${scope}#${fieldId}`（會 encodeURIComponent 後放進路徑）
 */
export const deleteField = async (docId, sectionIdFieldId) => {
  const encodedDocId = encodeURIComponent(docId)
  const encodedSectionIdFieldId = encodeURIComponent(sectionIdFieldId)

  try {
    const res = await axios.post(
      `/api/api-doc/v3/fields/${encodedDocId}/${encodedSectionIdFieldId}/delete`,
      null,
    )
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

/**
 * 批次寫入 fields（完整 field item 陣列，與 DynamoDB Put 一致）
 * @param {Array<Object>} data
 */
export const batchWriteFields = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v3/fields/batch-write', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

/**
 * 批次刪除 fields（每筆須含 docId、sectionIdFieldId；會遞迴刪子欄並重排同層 sortOrder）
 * @param {Array<{ docId: string, sectionIdFieldId: string }>} data
 * @returns {Promise<{ data?: { fieldsToUpdate: Array, missing?: Array }, message?: string }>}
 */
export const batchDeleteFields = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v3/fields/batch-delete', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

// ==================== Management API (與 v2 相同) ====================
export const getManagment = async () => {
  try {
    const res = await axios.get('/api/api-doc/v3/management')
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getManagementByEntityType = async (entityType) => {
  try {
    const res = await axios.get(`/api/api-doc/v3/management/${entityType}`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getManagementByEntityTypeAndId = async (entityType, id) => {
  try {
    const res = await axios.get(`/api/api-doc/v3/management/${entityType}/${id}`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const createManagementItem = async (data) => {
  try {
    const res = await axios.post(`/api/api-doc/v3/management/${data.entityType}`, data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const updateManagementItem = async (data) => {
  try {
    const res = await axios.post(`/api/api-doc/v3/management/${data.entityType}/${encodeURIComponent(data.id)}`, data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const deleteManagementItem = async ({ entityType, id }) => {
  try {
    const res = await axios.post(`/api/api-doc/v3/management/${entityType}/${encodeURIComponent(id)}/delete`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const uploadImage = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v3/upload', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const deleteImages = async (fileNames) => {
  try {
    const res = await axios.post('/api/api-doc/v3/upload/delete', fileNames)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

/**
 * Activity Log 列表
 * @param {{ from?: string, to?: string, editorUsername?: string, action?: string, keyword?: string, limit?: number }} params
 */
export const getActivityLogs = async (params = {}) => {
  try {
    const res = await axios.get('/api/api-doc/v3/activity-log', { params })
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

/**
 * 更新 Activity Log remark
 */
export const updateActivityLogRemark = async ({ id, at, remark }) => {
  try {
    const res = await axios.post('/api/api-doc/v3/activity-log/remark', { id, at, remark })
    return res.data
  } catch (error) {
    console.error('[ActivityLog] POST /activity-log/remark failed', error)
    const { data: errData } = error.response || {}
    return errData || { message: error.message }
  }
}

/**
 * 寫入 Activity Log（發佈請帶完整 detail.publishedDocsDataByDocId）
 */
export const createActivityLog = async (entry) => {
  try {
    const res = await axios.post('/api/api-doc/v3/activity-log', entry)
    return res.data
  } catch (error) {
    const { data: errData } = error.response || {}
    return errData || { message: error.message }
  }
}
